import { useState, useEffect } from 'react';
import throttle from 'lodash/throttle';
export function useScroll(padding) {
  const [sticky, setSticky] = useState(false);
  const [y, setY] = useState(0);
  const handleNavigation = throttle(() => {
    if (window.scrollY > padding) {
      // 'scroll down'
      if (window.scrollY > y) {
        setSticky(true);
      }

      // 'scroll up'
      if (window.scrollY < y) {
        setSticky(false);
      }
    } else {
      setSticky(false);
    }
    setY(window.scrollY);
  }, 100);
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    window.addEventListener('scroll', handleNavigation);
    return () => {
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [handleNavigation]);
  return sticky;
}